import { ICoreContext } from '@msdyn365-commerce/core';
import React, { useEffect } from 'react';
import { IOrderDetailResponse } from '../../../actions/order-details/get-order-details.action';
import { NO_DATA_FALLBACK, ORDER_DOCUMENTS_SECTION } from '../../../configuration';
import { ILocalizationState } from '../../../states/localization-state';
import { dateLocaleFormatter, formatTime, toLocalDate } from '../../../utilities';
import DocumentDownloadItem from '../../../utilities/document-download-item';
import { IOrderDetailsResources } from '../order-details.props.autogenerated';

export default function documentsTable({
    context,
    orderDetails,
    resources,
    localizationState
}: {
    context: ICoreContext;
    orderDetails: IOrderDetailResponse;
    resources: IOrderDetailsResources;
    localizationState: ILocalizationState;
}) {
    useEffect(() => {
        const scrollIntoView = () => {
            const hash = window.location.hash;

            if (hash) {
                const section = document.getElementById(hash.substring(1));
                if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };
        scrollIntoView();
    }, []);

    return (
        <>
            <h3 id={ORDER_DOCUMENTS_SECTION} className='ms-order-details__section-heading'>
                {resources.orderDetailsDocumentsTableHeading}
            </h3>
            {orderDetails.Documents?.length ? (
                <div className='table-responsive'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>{resources.orderDetailsDocumentsTabeleDocumentName}</th>
                                <th>{resources.orderDetailsDocumentsTableDate}</th>
                                <th>{resources.orderDetailsDocumentsTableLanguage}</th>
                                <th>{resources.orderDetailsDocumentsTableReference}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails.Documents?.map((documentItem, index) => (
                                <tr key={index}>
                                    <td>
                                        <DocumentDownloadItem
                                            context={context}
                                            resources={resources}
                                            documentItem={documentItem}
                                            index={index}
                                        />
                                    </td>
                                    <td>
                                        {documentItem.Date
                                            ? dateLocaleFormatter(localizationState).formatDate(toLocalDate(documentItem.Date))
                                            : NO_DATA_FALLBACK}{' '}
                                        {documentItem.Date ? formatTime(context, new Date(documentItem.Date)) : NO_DATA_FALLBACK}
                                    </td>
                                    <td>{documentItem.Language ?? NO_DATA_FALLBACK}</td>
                                    <td>{documentItem.Reference ?? NO_DATA_FALLBACK}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className='ms-order-details__documents-placeholder'>{resources.orderDetailsDocumentsEmpty}</p>
            )}
        </>
    );
}
